import React, { useEffect, useState } from "react";
import Loadspinner from "../../../common/Loadspinner";
import "react-toastify/dist/ReactToastify.css";
import "./CreateKnowledge.css";
import { Encrypt } from "../../../helpers/Cryptography/CryptoJS";
import { getFolders } from "../../../helpers/API/APIEndPoints";
import notify from "../../../ReusableComponents/ToastNotification/ToastNotification";
import { APICall } from "../../../helpers/API/APICalls";
import Main from "../../../common/Main/Main";
import { useHistory } from "react-router-dom";
import { storeInEncLocalStorage } from "../../../helpers/Utils/Utils";

function BulkUploadDocument() {
  const [isLoading, setLoading] = useState(false);

  // all folder
  const [folderName, setFolderName] = useState([]);
  const [pageSize, setPageSize] = useState(10);
  const [start, setStart] = useState(0);
  const [sortColumn, setSortColumn] = useState("");
  const [sortDirection, setSortDirection] = useState("");
  const [searchText, setSearchText] = useState("");
  const [count, setCount] = useState(0);
  const [icon, setIcon] = useState(true);
  let history = useHistory();

  useEffect(() => {
    getFoldersList();
  }, [start, sortColumn, sortDirection, searchText, count]);

  const getFoldersList = async () => {
    setLoading(true);
    let requestParams = {
      start: start,
      resultsPerPage: pageSize,
      searchText: searchText,
      sortColumn: sortColumn,
      sortDirection: sortDirection,
      isExport: false,
    };

    let data = await APICall(getFolders, requestParams, "POST");
    if (data.message === "Ok") {
      if (data && data.data.length > 0 && data.totalCount > 0) {
        await data.data.map((res) => {
          if (res.bulk_upload_status != null) {
            res.bulk_upload_status = res.bulk_upload_status
              .split(",")
              .map(Number);
          }
          return res;
        });
        setFolderName(data.data);
      }
    } else {
      notify(1, data.message);
      setLoading(false);
    }
    setLoading(false);
  };

  async function handleClick(url, value) {
    storeInEncLocalStorage("tokennumber", await Encrypt(JSON.stringify(value)));
    history.push({
      pathname: `${url}`,
    });
  }

  return (
    <>
      <Main active={"bulk_upload_document"} removeContainer={true}>
        <Loadspinner
          filename="BulkUploadDocument.js"
          isLoading={isLoading}
          isMiddle="false"
        />
        <div className="eventGallery">
          <div className="col-lg-12">
            <div className="row">
              <div className="col-md-6">
                <h4 style={{ paddingLeft: "15px" }}>
                  Knowledge Creation Bulk Upload
                </h4>
              </div>
              <div className="col-md-2"></div>

              <div className="col-md-4" style={{ padding: "0% 3% 0% 0%" }}>
                <div
                  className="float-right col-sm-offset-2"
                  style={{
                    marginBottom: 10,
                  }}
                >
                  <button
                    className="btn btn-danger"
                    style={{
                      marginLeft: 5,
                    }}
                    onClick={() => handleClick("bulk-upload-document/edit", 0)}
                  >
                    + Create Folder
                  </button>
                </div>
              </div>
            </div>

            <div
              className="d-flex align-items-center justify-space-between"
              style={{
                background: "#e61636",
                padding: "10px 20px 10px 10px",
                color: "white",
                width: "100%",
              }}
            >
              <div className="col-lg-8">Folders Names</div>
            </div>
          </div>
        </div>

        <div className="clearfix"></div>
        {/* style={{background:'white'}} */}
        <div className="container">
          <div style={{ borderRadius: "25px" }}>
            <div style={{ fontSize: "100px", color: "#ffc107" }}>
              <div className="col-lg-12 col-md-12">
                <div className="row" style={{ padding: "20px" }}>
                  {folderName?.map((items, index) => {
                    return (
                      <div
                        key={index}
                        className="col-lg-2 col-sm-2 col-xs-2 Icon-position-div"
                        style={{ fontSize: "100px", color: "#ffc107" }}
                      >
                        <figure>
                          {items.kcId != null ? (
                            items?.bulk_upload_status?.includes(0) ||
                            items?.bulk_upload_status?.includes(2) ? (
                              <i className="fa-solid fa-xmark Icon-position-cross"></i>
                            ) : (
                              <i className="fa-solid fa-check Icon-position"></i>
                            )
                          ) : (
                            ""
                          )}

                          <i
                            className="fa-solid fa-folder-open"
                            style={{ cursor: "pointer" }}
                            onClick={() => {
                              let val = {
                                FolderId: items.id,
                                FolderName: items.FolderName,
                              };
                              handleClick("kc-bulk-upload-document", val);
                            }}
                          ></i>
                          <figcaption
                            style={{
                              color: "black",
                              textAlign: "center",
                              fontSize: "12px",
                             
                              position: "absolute",
                            }}
                          >
                            {items.FolderName}
                          </figcaption>
                        </figure>
                      </div>
                    );
                  })}
                </div>
              </div>
            </div>
          </div>
        </div>
      </Main>
    </>
  );
}

export default BulkUploadDocument;
